import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-playercard',
  templateUrl: './playercard.component.html',
  styleUrls: ['./playercard.component.css']
})
export class PlayercardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
